import { render, staticRenderFns } from "./OrderSummaryCategory.vue?vue&type=template&id=05c38231&"
import script from "./OrderSummaryCategory.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports